// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false
	}
};

// Declare Templates
var bcSfFilterTemplate = {
	'saleLabelHtml': '<div class="sale_banner">' + bcSfFilterConfig.label.sale + '</div>',
	'newLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.new + '</div>',
	'comingsoonLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.coming_soon + '</div>',
	'preorderLabelHtml': '<div class="new_banner">' + bcSfFilterConfig.label.pre_order + '</div>',
	'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',
	'vendorHtml': '<div class="vendor"><span itemprop="brand">{{itemVendorLabel}}</span></div>',
	'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery"><span class="icon-plus"></span></span>',
	'newRowHtml': '<br class="clear product_clear" />',

	// Grid Template
	'productGridItemHtml': '<div class="product_item {{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupMobileClass}}" data-product-id="{{itemId}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product">' +
								'<a href="{{itemUrl}}" itemprop="url">' +
									'<div class="relative product_image">' +
										'<div class="product_container swap-' + bcSfFilterConfig.custom.collection_secondary_image + '">' +
											'{{itemImages}}' +
										'</div>' +
									'</div>' +
									'<div class="info">' +
										'<span class="title" itemprop="name">{{itemTitle}}</span>' +
										'{{itemVendor}}' +
										'{{itemReview}}' +
										'{{itemPrice}}' +
									'</div>' +
									'<div class="banner_holder">' +
										'{{itemSaleLabel}}' +
										'{{itemNewLabel}}' +
										'{{itemComingsoonLabel}}' +
										'{{itemPreorderLabel}}' +
									'</div>' +
								'</a>' +
								'{{itemSwatches}}' +
							'</div>',// +
							//'{{itemNewRow}}',

	// Pagination Template
	'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + bcSfFilterConfig.label.paginate_prev + '</a></span>',
	'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + bcSfFilterConfig.label.paginate_next + ' »</a></span>',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="bc-sf-filter-top-sorting-select" class="inline">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
	 /*** Prepare data ***/
	var images = data.images_info;
	 // Displaying price base on the policy of Shopify, have to multiple by 100
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices
	// Get First Variant (selected_or_first_available_variant)
	var firstVariant = data['variants'][0];
	if (getParam('variant') !== null && getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
	} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
				break;
			}
		}
	}
	/*** End Prepare data ***/

	var itemHtml = bcSfFilterTemplate.productGridItemHtml;

	var onSaleClass = onSale ? 'sale' : '';
	var soldOutClass = soldOut ? 'out_of_stock' : 'in_stock';

	var itemColumnNumberClass = '';
	var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, bcSfFilterConfig.custom.products_per_row);
	var itemCollectionGroupMobileClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
	switch (bcSfFilterConfig.custom.products_per_row) {
		case 2: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'six columns' : 'eight columns'; break;
		//case 3: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'four columns' : 'one-third column'; break;
        case 3: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'four columns' : 'four columns'; break;
		default: itemColumnNumberClass = bcSfFilterConfig.custom.show_sidebar ? 'three columns' : 'four columns'; break;
	}
	itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
	itemHtml = itemHtml.replace(/{{itemCollectionGroupMobileClass}}/g, itemCollectionGroupMobileClass);

	 // Get image source
	var imageSrc = 'data-src="' + this.getFeaturedImage(images, '2048x') + '" ';
	imageSrc += 'data-srcset=" ' + this.getFeaturedImage(images, '2048x') + ' 2048w,';
	imageSrc += this.getFeaturedImage(images, '1600x') + ' 1600w,';
	imageSrc += this.getFeaturedImage(images, '1200x') + ' 1200w,';
	imageSrc += this.getFeaturedImage(images, '1000x') + ' 1000w,';
	imageSrc += this.getFeaturedImage(images, '800x') + ' 800w,';
	imageSrc += this.getFeaturedImage(images, '600x') + ' 600w,';
	imageSrc += this.getFeaturedImage(images, '400x') + ' 400w"';
	// Get Thumbnail url
	var thumbUrl = this.getFeaturedImage(images, '100x');
	// Get Flip image url
	var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '900x') : this.getFeaturedImage(images, '900x');

	// Add Thumbnail
	var product_set_width = data.featured_image.width;
	var align_height_value = '';
	if (bcSfFilterConfig.custom.align_height) {
		if (images.length > 0) {
			var collection_height = bcSfFilterConfig.custom.collection_height;
			var product_aspect_ratio = images[0]['width'] / images[0]['height'];
			product_set_width = product_aspect_ratio * collection_height;
			if (images[0]['width'] >= images[0]['height']) {
				var align_height_value = 'width: 100%; height: auto;';
			} else {
				var align_height_value = 'width: 100%;';
			}
		}
	}
	var itemImagesHtml = '<div class="image__container" style="max-width: ' + product_set_width + 'px;">';
	itemImagesHtml += '<img  src="' + thumbUrl + '"' +
							'alt="{{itemTitle}}" ' +
							'class="lazyload lazyload--fade-in" ' +
							'style="' + align_height_value + ' max-width: ' + data.featured_image.width + 'px;" ' +
							'data-sizes="auto" ' + imageSrc + '/>';
	// Add Flip image
	if (bcSfFilterConfig.custom.collection_secondary_image) {
		itemImagesHtml += '<div class="image__container" style="max-width: ';
		if (images.length > 1) {
			itemImagesHtml += images[1]['width'] + 'px';
		} else {
			itemImagesHtml += data.featured_image.width + 'px';
		}
		itemImagesHtml += '">';
		itemImagesHtml += '<img src="' + itemFlipImageUrl + '" class="secondary lazyload" alt="{{itemTitle}}" />';
		itemImagesHtml += '</div>';
	}
	itemImagesHtml += bcSfFilterConfig.custom.quick_shop_enable ? '{{itemQuickViewBtn}}' : '';
	itemImagesHtml += '</div>';
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	// Add Labels
	// Sold Out label
	var itemSoldOutLabel = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	// Sale label
	var itemSaleLabel = bcSfFilterConfig.custom.sale_banner_enabled && onSale ? bcSfFilterTemplate.saleLabelHtml : '';
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	// New, Coming soon, Pre order label
	var itemNewLabelHtml = '', itemComingsoonLabelHtml = '', itemPreorderLabelHtml = '';
	if (data.collections) {
		var newLabel = data.collections.filter(function(e) { return e.handle == 'new'; });
		itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? bcSfFilterTemplate.newLabelHtml : '';

		var comingsoonLabel = data.collections.filter(function(e) { return e.handle == 'coming-soon'; });
		itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? bcSfFilterTemplate.comingsoonLabelHtml : '';

		var preorderLabel = data.collections.filter(function(e) { return e.handle == 'pre-order'; });
		itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? bcSfFilterTemplate.preorderLabelHtml : '';
	}
	itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);
	itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);
	itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);

	// Add Quick view button
	var itemQuickViewBtnHtml = bcSfFilterConfig.custom.quick_shop_enable ? bcSfFilterTemplate.quickViewBtnHtml : '';
	itemHtml = itemHtml.replace(/{{itemQuickViewBtn}}/g, itemQuickViewBtnHtml);

	// Add Review badge
	var itemReviewHtml = bcSfFilterConfig.custom.review_enable ? bcSfFilterTemplate.reviewHtml : '';
	itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

	// Add Vendor
	var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml : '';
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

	// Add Price
	var itemPriceHtml = '';
	itemPriceHtml += '<span class="price ' + onSaleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
	itemPriceHtml += '<meta itemprop="price" content="' + stripHtml(this.formatMoney(data.price_min)) + '" />';
	itemPriceHtml += '<meta itemprop="priceCurrency" content="' + bcSfFilterConfig.shop.currency + '" />';
	itemPriceHtml += '<meta itemprop="seller" content="' + bcSfFilterConfig.shop.name + '" />';
	itemPriceHtml += '<meta itemprop="availability" content="' + soldOutClass + '" />';
	itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
	if (!soldOut) {
		if (priceVaries && data.price_min > 0) {
			itemPriceHtml += '<small><em>' + bcSfFilterConfig.label.from_price + '</em></small> ';
		}
		if (data.price_min > 0) {
			itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
		} else {
			itemPriceHtml += bcSfFilterConfig.label.free_price;
		}
	} else {
		itemPriceHtml += '<span class="sold_out">' + bcSfFilterConfig.label.sold_out +'</span>';
	}
	if (onSale) {
		itemPriceHtml += ' <span class="was_price"><span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span></span>';
	}
	itemPriceHtml += '</span>';
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	// Add Color swatches
	var itemSwatchHtml = '';
	if(bcSfFilterConfig.custom.collection_swatches){
		for (var k in data.options) {
			if (data['options'][k].indexOf('color') > -1 || data['options'][k].indexOf('couleur') > -1) {
				var selectedOption = data['options'][k];
				var values = [];
				itemSwatchHtml += '<div class="collection_swatches">';
				for (var i = 0; i < data['variants'].length; i ++) {
					var value = data['variants'][i]['option_' + selectedOption];
					if (values.indexOf(value) == -1) {
						values = values.join(',');
						values += ',' + value;
						values = values.split(',');
						var variantImage = bcSfFilterConfig.general.no_image_url;
						var temp = data.options_with_values.filter(function(e){ return e.name == selectedOption; });
						if (typeof temp[0] !== 'undefined') {
							var optionValues = temp[0]['values'].filter(function(e){ return e.title == value });
							if (typeof optionValues[0] !== 'undefined') {
								var imageIndex = optionValues[0]['image'];
								if (typeof (data['images'][imageIndex]) !== 'undefined') {
									variantImage = data['images'][imageIndex]['src'];
								}
							}
						}
						if (variantImage !== '') {
							itemSwatchHtml += '<a href="' + this.buildProductItemUrl(data) + '?variant=' + data['variants'][i]['id'] +  '" class="swatch">';
							itemSwatchHtml += '<span data-image="' + this.optimizeImage(variantImage, '1024x1024') + '" style="background-color: ' + value + '; background-image: url(' + bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', value + '_50x.png') + ');"></span>'
							itemSwatchHtml += '</a>';
						}
					}
				}
				itemSwatchHtml += '</div>';
			}
		}
	}
	itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchHtml);

	// Add new row
	var itemNewRowHtml = index % bcSfFilterConfig.custom.products_per_row == 0 ? bcSfFilterTemplate.newRowHtml : '';
	itemHtml = itemHtml.replace(/{{itemNewRow}}/g, itemNewRowHtml);

	// Add main attribute
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

	return itemHtml;
};

// Build advanced class
function buildItemCollectionGroupThumbClass(index, productsPerRow) {
	var temp = index < productsPerRow ? index : index % productsPerRow;
	if (temp == 0) { return 'omega'; }
	else if (temp == 1) { return 'alpha'; }
	return '';
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.bottomPagination).html('');
		return false;
	}

	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);

		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		jQ(this.selector.bottomPagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');

		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);

			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
	if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
		var colInfo = colData.collection;

		var breadcrumbHtml = '<span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="' + bcSfFilterConfig.shop.url + '" title="' + bcSfFilterConfig.shop.name  + '" itemprop="item"><span itemprop="name">' + bcSfFilterConfig.label.breadcrumb_home + '</span></a></span>';
		breadcrumbHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
		breadcrumbHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/' + colInfo.handle + '" title="{{currentCollectionTitle}}" itemprop="item"><span itemprop="name">{{currentCollectionTitle}}</span></a></span>';
		// Build Tags
		var currentTagsHtml = '';
		if (Array.isArray(bcSfFilterConfig.general.current_tags)) {
			var current_tags = bcSfFilterConfig.general.current_tags;
			for (var k in current_tags) {
				var tag = current_tags[k];
				currentTagsHtml += ' &nbsp;<span class="icon-arrow-right"></span>';
				currentTagsHtml += ' <span itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem"><a href="/collections/{{currentCollectionLink}}" title="' + tag + '" itemprop="item"><span itemprop="name">' + tag + '</span></a></span>';
			}
		}
		breadcrumbHtml += currentTagsHtml;
		// Build Collection Info
		breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
		// Top Pagination
		// var currentPage = parseInt(this.queryParams.page);
		// var totalPage = Math.ceil(apiData.total_product / this.queryParams.limit);
		// var topPaginationHtml = ' &nbsp;<span class="icon-arrow-right"></span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage)
		// breadcrumbHtml += topPaginationHtml;
		breadcrumbHtml += ' <span id="bc-sf-filter-top-pagination"></span>';

		jQ('.breadcrumb_text').html(breadcrumbHtml);
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
	buildTheme();
	if (!this.isMobile() && bcSfFilterConfig.custom.quick_shop_enable) {
		// Build content for Quick view
		var count = 0;
		data.forEach(function(product){
			var url = bcsffilter.buildProductItemUrl(product, true);
			jQ.ajax({
				type: "GET",
				url: url + '?view=quickview',
				success: function(result){
					if (jQ('.modal#product-' + product.id).length == 0 && jQ('[data-product-id="'+ product.id +'"]').length == 1){
						jQ(result).insertAfter(jQ('[data-product-id="'+ product.id +'"]'));
					}
					count++;
					if (count == data.length){
						buildTheme();
					}
				}
			});
		})
	}
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
	// Add Wrapper for Product list
	if (jQ('#bc-sf-filter-products').children().hasClass('products')) {
		jQ('#bc-sf-filter-products').children().children().unwrap();
	}

	// Build Top Pagination
	var totalPage = Math.ceil(data.total_product / this.queryParams.limit);
	var topPaginationHtml = '&nbsp;<span class="icon-arrow-right"></span> ' + (bcSfFilterConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, this.queryParams.page).replace(/{{ pages }}/g, totalPage);
	jQ('#bc-sf-filter-top-pagination').html(topPaginationHtml);
};

function buildTheme(){
	collection.init();
	Shopify.PaymentButton.init();
	if (bcSfFilterConfig.custom.show_multiple_currencies && window.convertCurrencies && typeof convertCurrencies == 'function'){
		convertCurrencies();
	}
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
